import HTTP from '../HTTP';

const CONTACTS_URL = 'contacts';

export async function browseContacts(query) {
  try {
    const response = await HTTP.get(CONTACTS_URL, { params: { query } });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function other() {
  try {
    const response = await HTTP.get(CONTACTS_URL);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function addContact(data) {
  try {
    const response = await HTTP.post(CONTACTS_URL, data);
    return response;
  } catch (e) {
    throw e;
  }
}



// WEBPACK FOOTER //
// ./src/api/contacts/index.js